import {useQueryClient} from '@tanstack/react-query'

import {materialStorageHistoryQueryOptions} from './materialStorageHistoryQueryOptions'

export const usePrefetchMaterialStorageHistory = (plantId: string, from: string, to: string) => {
  const queryClient = useQueryClient()
  void queryClient.prefetchQuery(materialStorageHistoryQueryOptions(plantId, from, to))
}
